module.exports = __webpack_public_path__ + "assets/startpage-1dd318613c1721a2526c040f32c6e0c9.png";


//////////////////
// WEBPACK FOOTER
// ./pages/Website/assets/startpage.png
// module id = 641
// module chunks = 0 1